import { ImageRef } from '../types/image';

export const ImageApis = {
  getUrlFor(code: ImageRef): string {
    // Suppot absolute urls for testing purpose
    if (code.startsWith('http://') || code.startsWith('https://')) {
      return code;
    }
    return `/api/v3/uploaded/images/${code}`;
  },
  async getAsBlob(code: ImageRef): Promise<Blob> {
    const response = await fetch(this.getUrlFor(code));
    return response.blob();
  },
};
